import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookie-consent", "declined");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-card border-t border-border shadow-lg z-50 animate-fade-in">
      <div className="container mx-auto px-4 py-4 max-w-4xl">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-sm font-semibold mb-2">🍪 We Value Your Privacy</h3>
            <p className="text-sm text-foreground">
              We use cookies and similar technologies to enhance your browsing experience, analyze site traffic, 
              and display personalized advertisements through Google AdSense and our advertising partners. 
              By clicking "Accept All," you consent to our use of cookies. You can manage your preferences or 
              learn more in our{" "}
              <a href="/privacy" className="text-primary hover:underline font-medium">
                Privacy Policy
              </a>
              .
            </p>
          </div>
          <div className="flex items-center gap-3 shrink-0 flex-wrap sm:flex-nowrap">
            <Button variant="outline" size="sm" onClick={handleDecline}>
              Decline Non-Essential
            </Button>
            <Button size="sm" onClick={handleAccept} className="bg-primary text-primary-foreground">
              Accept All
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
